/* FVS Step 11 and Step 20 */
/* eslint-disable operator-linebreak */
import { ReactElement } from 'react';
import { Field, useFormikContext } from 'formik';
import { iFVSFormValues } from '@services/FVSService';
import { tile, iFVSInfoDisplay } from '@interfaces/interfaces';
import { TileRadio, Alert } from '@components';
import FVSStep11AlertContent from '@components/Content/AlertContent/FVSStep11AlertContent';
import gridStyles from '@pages/forms/Grid.module.scss';
import InfoIcon from '../../images/info.svg';

interface iPaymentArrangements {
  displayObject: iFVSInfoDisplay;
  currentStepNo: string;
}

function PaymentArrangements({ displayObject, currentStepNo }: iPaymentArrangements): ReactElement {
  const YesValue = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
  ];
  const { values }: { values: iFVSFormValues } = useFormikContext();
  const { pageTitle, pageSubtitle } = displayObject.pages.paymentArrangements[currentStepNo];
  const { removeFines, reincludeFines } = displayObject.pages.paymentArrangements[currentStepNo].fields;

  return (
    <div className={gridStyles.form}>
      <span className="vfH2">{pageTitle}</span>
      {currentStepNo === 'step11' && <span className="subHeadingH3">It appears that one or more of the fines in your application are in a payment arrangement.</span>}
      <span className="subHeadingH3">{pageSubtitle}</span>
      {currentStepNo === 'step20' && (
        <div className={gridStyles.gridColFull}>
          <Field
            name="HasPaymentArrangement"
            title="Does the fineholder have a payment arrangement with Fines Victoria for any of the fines in this application?"
            component={TileRadio}
            tileData={TILE_DATA}
            orientationRow
            isMandatory
          />
          {values.HasPaymentArrangement === 'true' && (
            <Alert message="Please note if they pay the fines in full, they will no longer be eligible for the scheme" theme="info" icon={InfoIcon} />
          )}
        </div>
      )}
      {(currentStepNo === 'step11' || values.HasPaymentArrangement === 'true') && (
        <div className={gridStyles.gridColFull}>
          <Field name={removeFines.formikName} title={removeFines.title} component={TileRadio} tileData={TILE_DATA} orientationRow isMandatory />
        </div>
      )}
      {values.RemoveFines === 'true' && (
        <div className={gridStyles.gridColFull}>
          <Field name={reincludeFines.formikName} title={reincludeFines.title} component={TileRadio} tileData={TILE_DATA} orientationRow isMandatory />
        </div>
      )}
      <div className={gridStyles.gridColFull}>
        <Alert message={<FVSStep11AlertContent />} theme="info" icon={InfoIcon} />
      </div>
    </div>
  );
}

export default PaymentArrangements;
